module.exports = __webpack_public_path__ + "img/community_build.7b81ca7c.svg";